module.exports = __webpack_public_path__ + "static/media/edit-pencil-dark.9877dc83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/icons/edit-pencil-dark.svg
// module id = 829
// module chunks = 0